'use strict';

//
// Сохранение текстовых контейнеров по мере их ввода
//
(function () {
    $(document).on('keyup', '.text-content[contenteditable]', (e) => {
        $(e.target).closest('.page-container.editing').trigger(Fotobook.events.TEXT_CONTAINER_CHANGED);
    });


    $(document).on(Fotobook.events.TEXT_CONTAINER_CHANGED, (e) => {
        const $container = $(e.target).closest('.page-container.editing');
        const timer = $container.data('saveTimer');

        if (timer) {
            clearTimeout(timer);
        }
        $container.data('saveTimer', setTimeout(() => {
            $container.data('saveTimer', null);

            const widget = $container.data('fotobook-containerEditor');
            if (!widget) {
                return;
            }
            widget.validateTextContainer({ alert: true }).finally(() => {
                widget.saveTextContainer();
            });
        }, 1000));
    });
})();
